import { render, staticRenderFns } from "./ManLoadsPage.vue?vue&type=template&id=2690e5b2&scoped=true&"
import script from "./ManLoadsPage.vue?vue&type=script&lang=js&"
export * from "./ManLoadsPage.vue?vue&type=script&lang=js&"
import style0 from "./ManLoadsPage.vue?vue&type=style&index=0&id=2690e5b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2690e5b2",
  null
  
)

export default component.exports